module.exports = __webpack_public_path__ + "img/prize7.b968767b.png";